// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 676 ? "9932c28f" : chunkId) + "." + {"269":"836f14d0e53b1e4a","676":"bbb4399bd6d1079e","975":"4137fc0934267778"}[chunkId] + ".js";
};